import { connect } from 'react-redux';
import ReviewPanel from './ReviewPanel';
import { updateReview } from '../../actions/reviews';

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    updateReview: body => dispatch(updateReview(body)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewPanel);
